import { httpClient } from '@/services/http/httpClient'

export type GetTenantConfigsResponse = {
  id: string
  tenantId: string
  msalClientId?: string
  msalAuthority?: string
  msalRedirectUri?: string
  msalGroupId?: string
  msalClientSecret?: string
  hasProjectModule?: boolean
  hasOpenInnovationModule?: boolean
  hasAIService?: boolean
}

export async function getConfigs(): Promise<GetTenantConfigsResponse> {
  const { data } = await httpClient.get(`/tennants/config`)

  return {
    id: data.config.id,
    tenantId: data.config.tennantId,
    msalClientId: data.config?.msalClientId,
    msalAuthority: data.config?.msalAuthority,
    msalRedirectUri: data.config?.msalRedirectUri,
    msalGroupId: data.config?.msalGroupId,
    msalClientSecret: data.config?.msalClientSecret,
    hasProjectModule: data.config?.hasProjectModule,
    hasOpenInnovationModule: data.config?.hasOpenInnovationModule,
    hasAIService: data.config?.hasAIService,
  }
}
